// extracted by mini-css-extract-plugin
export default {"wrapper":"fqS7jk7j3g","row":"h5EENnHg8x","header":"acti0nF8KJ","title":"KeHRu0_jGt","section":"G1YCdJwcsj"};